import React from 'react';

import { Box, keyframes } from '@edreamsodigeo/prisma-design-system';

const fadeIn = keyframes`
  0% {
    opacity:0.3;
  }
  100% {
    opacity: 1;
  }
`;

export const FadeIn = ({ children, duration, delay }) => (
  <Box
    sx={{
      animationName: `${fadeIn}`,
      animationDuration: `${duration}ms`,
      animationDelay: `${delay || 0}ms`,
      opacity: 1,
    }}
  >
    {children}
  </Box>
);
